import React from "react";
import { connect } from "react-redux";
import PmaMailingList from "./PmaMailingList";
import { pmaActions } from "../../../_store/_actions";
import "../index.scss";
import DocumentTitle from "react-document-title";
import PMANavbar from "../PMANavbar";
import { CircularProgress, Typography } from '@mui/material';
import { propertyUtil } from "../PropertyUtil";
import { GetStateStorage } from "common/storage";
import UnderConstruction from "views/Pma/PmaEditor/UnderConstruction";
import { renderLogicUtil } from "../RenderLogicUtil";
import { LOG_MODULES, LOG_CODE_PREFIX, trackException } from "common/errorTracker";

const AgentMailProLoader = () => {
  return (
    <div
      style={{
        height: "80vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        background: "inherit",
      }}
    >
      <div>
        <CircularProgress />
      </div>
      <div>
        <Typography variant="subtitle2">&nbsp;&nbsp;Loading MailPro</Typography>
        <Typography variant="body1">
          &nbsp;&nbsp;This may take a few seconds. Lots of data is being
          collected!
        </Typography>
      </div>
    </div>
  );
};

class MailProInit extends React.Component {
  constructor(props) {
    super(props);
    this.localMailProDataRef = React.createRef(null);
  }

  async componentDidMount() {
    let { paramAreaID } = this.props;
    const stateData = GetStateStorage();
    const agentData = stateData.userData;
    let navbarData =
      agentData && Array.isArray(agentData.navbarInfo)
        ? (agentData.navbarInfo.find(
            (area) => String(area.mlsAreaID) === String(paramAreaID)
          ) || agentData.navbarInfo[0] || {})
        : {};
    // Don't call switchArea here to avoid resetting propertyData
    this.initiMailProData();
    window.scrollTo(0, 0);

    // If MailPro is still on the loading screen after 25s, something in the
    // data chain (print date / mailer data / navbar) silently failed — trace it.
    this.stuckLoadingTimerRef = setTimeout(() => {
      const { nextPMAPrintDate, propertyData } = this.props;
      const stillLoading = !propertyData || propertyData.length === 0;
      if (stillLoading) {
        trackException({
          module: LOG_MODULES.MAILPRO,
          code: `${LOG_CODE_PREFIX.MAILPRO}STUCK_LOADING`,
          error: new Error('MailPro still on loading screen after 25s'),
          level: 'warning',
          data: {
            paramAreaID: this.props.paramAreaID,
            hasNextPMAPrintDate: !!nextPMAPrintDate,
            hasPropertyData: Boolean(propertyData && propertyData.length),
          },
        });
      }
    }, 25000);
  }

  componentWillUnmount() {
    clearTimeout(this.stuckLoadingTimerRef);
  }

  componentDidUpdate(prevProps) {
    const prevID = prevProps.paramAreaID;
    const currentID = this.props.paramAreaID;
    const prevNext = prevProps.nextPMAPrintDate;
    const currNext = this.props.nextPMAPrintDate;

    const areaChanged = String(prevID) !== String(currentID);
    const nextDateBecameAvailable = prevNext !== currNext && !!currNext;
    const needsData = !this.props.propertyData || this.props.propertyData.length === 0;

    if (areaChanged || (nextDateBecameAvailable && needsData)) {
      this.initiMailProData();
    }
  }  

  initiMailProData = () => {
    const {
      paramAreaID,
      agentData,
      nextPMAPrintDate,
      propertyData,
    } = this.props;
  
    
    try {
      // Always fetch data if we have the required parameters
      if (nextPMAPrintDate && paramAreaID) {
        this.props.getMailerProDetails(
          String(paramAreaID),
          agentData,
          nextPMAPrintDate
        );
        window.scrollTo(0, 0);
      }
    } catch (error) {
      trackException({
        module: LOG_MODULES.MAILPRO,
        code: `${LOG_CODE_PREFIX.MAILPRO}INIT_FAILED`,
        error,
        data: { paramAreaID },
      });
    }
  };

  forceUpdateAgentPMA = () => {
    this.forceUpdate();
  };

  resetLocalMailProRefFn = () => {
    if (this.localMailProDataRef.current) {
      this.localMailProDataRef.current.resetMailProLocalState();
    }
  };

  render() {
    const {
      currentStep,
      propertyData,
      pma,
      mlsAreaIds,
      mlsAreas,
      currentArea,
      agentData,
      isLoading,
      navbarData,
      handleDrawerOpen,
      enableMailProApprovalProcess,
      singleHOData,
      isUnavailable,
    } = this.props;

    /**Get Unapproved areas */
    const { showBox, areaCount } = propertyUtil.getUnapprovedAreaCount(
      mlsAreas
    );

    const forceBlockEditing = renderLogicUtil.getForceBlockEditing(agentData);
    const isMailProLocked =
      propertyUtil.shouldBlockMailPro(agentData.mailProStatus) ||
      forceBlockEditing ||
      (currentArea || {}).mailingStatus === "Approved";

    const PMANavCopy = (
      <PMANavbar
        propertyData={propertyData}
        agentData={agentData}
        pma={pma}
        mlsAreas={mlsAreas}
        currentArea={currentArea}
        navbarData={navbarData}
        handleDrawerOpen={handleDrawerOpen}
        isLoading={isLoading}
        showUnapprovedBox={showBox}
        unapprovedAreaCount={areaCount}
        enableMailProApprovalProcess={enableMailProApprovalProcess}
        isMailProLocked={isMailProLocked}
        resetLocalMailProRefFn={this.resetLocalMailProRefFn}
        isUnavailable={isUnavailable}
      />
    );

    if (isUnavailable) {
      return (
        <DocumentTitle title={"MailPro | ListGen"}>
          <div className="pma-creator">
            <main>
              {PMANavCopy}
              <section
                className={`pma-margin-top ${
                  currentStep === 1 ? "pma-margin-top-mailpro" : ""
                }`}
              >
                <UnderConstruction
                  altIssue={true}
                  fromMailPro={true}
                  agentData={agentData}
                  currentArea={currentArea}
                />
              </section>
            </main>
          </div>
        </DocumentTitle>
      );
    } else {
      return (
        <DocumentTitle title={"MailPro | ListGen"}>
          <div className="pma-creator">
            <main>
              {PMANavCopy}
              <section
                className={`pma-margin-top ${
                  currentStep === 1 ? "pma-margin-top-mailpro" : ""
                }`}
              >
                {singleHOData && propertyData ? (
                  <div className="section-pma-mailing-list">
                    <PmaMailingList
                      agentData={agentData}
                      propertyData={propertyData}
                      mlsAreas={mlsAreaIds}
                      currentArea={currentArea}
                      isLoading={isLoading}
                      newMailingForceUpdate={this.forceUpdateAgentPMA}
                      isMailProLocked={isMailProLocked}
                      ref={this.localMailProDataRef}
                    />
                  </div>
                ) : (
                  <AgentMailProLoader />
                )}
              </section>
            </main>
          </div>
        </DocumentTitle>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    singleHOData: state.pma.singleHOData,
    currentStep: state.pma.currentStep,
    currentArea: state.pma.currentArea,
    propertyData: state.pma.propertyData,
    pma: state.pma,
    mlsAreaIds: state.pma.mlsAreaIds,
    isLoading: state.pma.isLoading,
    nextPMAPrintDate: state.pma.nextPMAPrintDate,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getMailerProDetails: (areaId, agentData, nextPMAPrintDate) => {
      dispatch(
        pmaActions.getMailProMailerData(areaId, agentData, nextPMAPrintDate)
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MailProInit);
